import { ErrorCode } from '@openfeature/react-sdk';

export enum FeatureFlagErrorCode {
  PROVIDER_ERROR = 'PROVIDER_ERROR',
  FLAG_ERROR = 'FLAG_ERROR',
  FLAG_NOT_FOUND = 'FLAG_NOT_FOUND',
  CONTEXT_ERROR = 'CONTEXT_ERROR',
  GENERAL_ERROR = 'GENERAL_ERROR',
}

export interface FeatureFlagMetadata {
  code: FeatureFlagErrorCode;
  message: string;
}

export interface FeatureFlagErrorHookMetadata {
  flagKey: string;
  flagValueType: string;
}

export function toFeatureFlagErrorCode(errorCode: ErrorCode): FeatureFlagErrorCode {
  switch (errorCode) {
    case ErrorCode.PROVIDER_FATAL:
    case ErrorCode.PROVIDER_NOT_READY:
      return FeatureFlagErrorCode.PROVIDER_ERROR;
    case ErrorCode.FLAG_NOT_FOUND:
      return FeatureFlagErrorCode.FLAG_NOT_FOUND;
    case ErrorCode.TYPE_MISMATCH:
    case ErrorCode.PARSE_ERROR:
      return FeatureFlagErrorCode.FLAG_ERROR;
    case ErrorCode.TARGETING_KEY_MISSING:
    case ErrorCode.INVALID_CONTEXT:
      return FeatureFlagErrorCode.CONTEXT_ERROR;
    default:
      return FeatureFlagErrorCode.GENERAL_ERROR;
  }
}

export function getFeatureFlagErrorDetails(errorCode: ErrorCode): FeatureFlagMetadata {
  switch (errorCode) {
    case ErrorCode.PROVIDER_FATAL:
      return { code: FeatureFlagErrorCode.PROVIDER_ERROR, message: 'Provider fatal error' };
    case ErrorCode.PROVIDER_NOT_READY:
      return { code: FeatureFlagErrorCode.PROVIDER_ERROR, message: 'Provider error' };
    case ErrorCode.FLAG_NOT_FOUND:
      return { code: FeatureFlagErrorCode.FLAG_NOT_FOUND, message: 'Flag not found' };
    case ErrorCode.TYPE_MISMATCH:
      return { code: FeatureFlagErrorCode.FLAG_ERROR, message: 'Flag type mismatch' };
    case ErrorCode.PARSE_ERROR:
      return { code: FeatureFlagErrorCode.FLAG_ERROR, message: 'Flag parse error' };
    case ErrorCode.TARGETING_KEY_MISSING:
      return { code: FeatureFlagErrorCode.CONTEXT_ERROR, message: 'Targeting key missing' };
    case ErrorCode.INVALID_CONTEXT:
      return { code: FeatureFlagErrorCode.CONTEXT_ERROR, message: 'Invalid context' };
    default:
      return { code: FeatureFlagErrorCode.GENERAL_ERROR, message: 'Unknown error' };
  }
}

export class FeatureFlagError extends Error {
  readonly code: FeatureFlagErrorCode;
  readonly metadata?: FeatureFlagErrorHookMetadata;

  constructor(
    code: FeatureFlagErrorCode,
    message: string,
    metadata?: FeatureFlagErrorHookMetadata
  ) {
    super(message);
    this.name = 'FeatureFlagError';
    this.code = code;
    this.metadata = metadata;
  }
}
